if (!customElements.get('product-swatches')) {
  class ProductSwatches extends HTMLElement {
    constructor() {
      super();
      this.swatches = this.querySelectorAll('.swatch');
      this.boundHandleSwatchClick = this.handleSwatchClick.bind(this);
      this.boundQuickshopSwatchClick = this.handleQuickshopSwatchClick.bind(this);
      this.boundBundleSwatchClick = this.handleBundleSwatchClick.bind(this);
      this.isQuickshop = this.closest('quickshop-drawer');
      this.customSwatchesTrigger = document.querySelector('.product-checkbox-bundle');
    }

    connectedCallback() {
      this.isBundle = this.dataset.isBundle === 'true';
      this.updateAvailabilityStyle();
      if (this.isQuickshop) {
        this.swatches.forEach((swatch) => {
          swatch.addEventListener('click', this.boundQuickshopSwatchClick);
        });
      } else if (this.isBundle) {
        this.smpBundle = this.closest('smp-bundle');
        this.swatches.forEach((swatch) => {
          swatch.addEventListener('click', this.boundBundleSwatchClick);
        });
      } else {
        this.swatches.forEach((swatch) => {
          swatch.addEventListener('click', this.boundHandleSwatchClick);
        });
      }
    }

    disconnectedCallback() {
      if (this.isQuickshop) {
        this.swatches.forEach((swatch) => {
          swatch.removeEventListener('click', this.boundQuickshopSwatchClick);
        });
      } else if (this.isBundle) {
        this.swatches.forEach((swatch) => {
          swatch.removeEventListener('click', this.boundHandleSwatchClick);
        });
      } else {
        this.swatches.forEach((swatch) => {
          swatch.removeEventListener('click', this.boundHandleSwatchClick);
        });
      }
    }

    handleSwatchClick(event) {
      const swatch = event.target.closest('.swatch');
      const newUrl = swatch.dataset.url;

      const selectedSwatch = this.querySelector('.swatch.selected');
      if (selectedSwatch) {
        selectedSwatch.classList.remove('selected');
      }

      swatch.classList.add('selected');
      this.updateSwatchLabel(swatch);

      const variantId = document.querySelector('product-form input[type="hidden"][name="id"]');
      const productId = document.querySelector('product-form input[type="hidden"][name="product-id"]');

      variantId && (variantId.value = swatch.dataset.variantId);
      productId && (productId.value = swatch.dataset.productId);

      if (window.fbq && swatch.dataset.variantId) {
        try {
          const productTitleElement = document.querySelector('.Product-title') || document.querySelector('h1');
          let productTitle = productTitleElement?.textContent || 'Product';

          productTitle = productTitle.replace(/\s+/g, ' ').trim();

          const colorLabel = swatch.dataset.colorLabel || '';
          const contentName = colorLabel ? `${productTitle} - ${colorLabel}` : productTitle;

          const priceInCents = parseFloat(swatch.dataset.price) || 0;
          const priceInDollars = priceInCents / 100;

          window.fbq('track', 'ViewContent', {
            content_ids: [swatch.dataset.variantId],
            content_name: contentName,
            content_type: 'product_group',
            currency: 'USD',
            value: priceInDollars,
          });
        } catch (error) {
          console.error('Error firing ViewContent event:', error);
        }
      }

      if (newUrl) {
        window.history.pushState({ path: newUrl }, '', newUrl);
        this.updateSections(newUrl);
        this.closest('product-info').setAttribute('data-url', newUrl.split('?')[0]);
      }

      this.updateAvailabilityStyle();
    }

    async updateSections(url) {
      const sectionId = this.dataset.sectionId;
      const data = await fetch(`${url}&section_id=${sectionId}`);

      const html = await data.text();
      const parser = new DOMParser();
      this.doc = parser.parseFromString(html, 'text/html');

      const oldBulkAdd = document.querySelector('#bulk-add');
      const newBulkAdd = this.doc.querySelector('#bulk-add');

      const oldPresaleMessage = document.querySelector('#final-sale');
      const newPresaleMessage = this.doc.querySelector('#final-sale');

      const variantSelects = document.querySelector('variant-selects');

      // IMPORTANT: Replace button container FIRST, before custom-swatches initializes
      // This ensures custom-swatches.initialize() finds the correct button reference
      this.replaceHTML('.quantity-buy-btn-container');

      const oldBundleCheckbox = document.querySelector('.product-checkbox-bundle');
      const newBundleCheckbox = this.doc.querySelector('.product-checkbox-bundle');

      const oldCustomSwatches = document.querySelector('custom-swatches');
      const newCustomSwatches = this.doc.querySelector('custom-swatches');

      // Preserve the expanded state before replacements
      const wasExpanded = oldCustomSwatches && oldCustomSwatches.dataset.collapsed === 'false';

      if (oldBundleCheckbox && !newBundleCheckbox) {
        oldBundleCheckbox.remove();
      } else if (!oldBundleCheckbox && newBundleCheckbox) {
        document
          .querySelector('.quantity-buy-btn-container')
          .insertAdjacentHTML('beforebegin', newBundleCheckbox.outerHTML);
      } else if (oldBundleCheckbox && newBundleCheckbox) {
        if (wasExpanded) {
          newBundleCheckbox.classList.add('background');
          const input = newBundleCheckbox.querySelector('input');
          const checkbox = newBundleCheckbox.querySelector('.custom-purchase-option-checkbox');
          if (input) input.checked = true;
          if (checkbox) checkbox.classList.add('custom-checkbox-check');
        }
        oldBundleCheckbox.replaceWith(newBundleCheckbox);
      }

      if (oldCustomSwatches && !newCustomSwatches) {
        oldCustomSwatches.remove();
      } else if (!oldCustomSwatches && newCustomSwatches) {
        const clonedElement = newCustomSwatches.cloneNode(true);
        if (wasExpanded) {
          clonedElement.setAttribute('data-fetch-rendered', 'true');
        }
        document.querySelector('.product-checkbox-bundle').insertAdjacentElement('beforebegin', clonedElement);
      } else if (oldCustomSwatches && newCustomSwatches) {
        if (wasExpanded) {
          newCustomSwatches.setAttribute('data-fetch-rendered', 'true');
        }
        oldCustomSwatches.replaceWith(newCustomSwatches);
      }

      // document.querySelector('custom-swatches')?.clear();
      // document.querySelector('custom-swatches')?.initialize();

      const embroideryToggleContainer = document.querySelector('.embroidery-toggle-container');
      if (embroideryToggleContainer && !this.doc.querySelector('.embroidery-toggle-container')) {
        embroideryToggleContainer.remove();
      } else if (!embroideryToggleContainer && this.doc.querySelector('.embroidery-toggle-container')) {
        document
          .querySelector('.quantity-buy-btn-container')
          .insertAdjacentElement('beforebegin', this.doc.querySelector('.embroidery-toggle-container'));
      } else if (embroideryToggleContainer && this.doc.querySelector('.embroidery-toggle-container')) {
        embroideryToggleContainer.replaceWith(this.doc.querySelector('.embroidery-toggle-container'));
      }

      const embroideryPopup = document.querySelector('embroidery-popup');
      if (embroideryPopup && !this.doc.querySelector('embroidery-popup')) {
        embroideryPopup.remove();
      } else if (!embroideryPopup && this.doc.querySelector('embroidery-popup')) {
        document
          .querySelector('product-info')
          .insertAdjacentElement('beforebegin', this.doc.querySelector('embroidery-popup'));
      } else if (embroideryPopup && this.doc.querySelector('embroidery-popup')) {
        embroideryPopup.replaceWith(this.doc.querySelector('embroidery-popup'));
      }

      const finalSaleInput = document.querySelector('product-form input[name="properties[Heads Up]"]');
      if (finalSaleInput && newPresaleMessage) {
        finalSaleInput.value = 'This item is final sale. No returns or exchanges.';
      } else if (finalSaleInput && !newPresaleMessage) {
        finalSaleInput.value = null;
      }

      if (oldPresaleMessage && newPresaleMessage) {
        oldPresaleMessage.replaceWith(newPresaleMessage);
      } else if (!oldPresaleMessage && newPresaleMessage) {
        document.querySelector('variant-selects').insertAdjacentHTML('afterend', newPresaleMessage.outerHTML);
      } else if (oldPresaleMessage && !newPresaleMessage) {
        oldPresaleMessage.remove();
      }

      if (oldBulkAdd && !newBulkAdd) {
        oldBulkAdd.remove();
      } else if (!oldBulkAdd && newBulkAdd) {
        document.querySelector('.quantity-buy-btn-container').insertAdjacentHTML('afterend', newBulkAdd.outerHTML);
        document.querySelector('product-info').refreshBulkAdd();
      } else {
        console.log('no changes', oldBulkAdd, newBulkAdd);
      }

      this.replaceHTML('.product__media-wrapper');
      this.replaceHTML('.pdp-price-container');
      this.replaceHTML('.v2-flex-right');
      this.replaceHTML('product-tabs');
      this.replaceHTML('script[data-selected-variant]');
      this.replaceHTML('variant-selects');
      // .quantity-buy-btn-container already replaced earlier (before custom-swatches init)
      this.replaceHTML('.klaviyo-bis-modal');
      this.replaceHTML('bis-trigger');
      this.replaceHTML('quantity-input');
      this.replaceHTML('quantity-select');

      // TODO: Fix this to be more specific
      this.replaceHTML('.shopify-app-block');

      // document.querySelector('custom-swatches')?.clear();
      // document.querySelector('custom-swatches')?.initialize();
    }

    replaceHTML(selector) {
      const oldEl = document.querySelector(selector);
      const newEl = this.doc.querySelector(selector);

      if (this.doc && oldEl && newEl) {
        oldEl.replaceWith(newEl);
      }
    }

    formatPrice(price) {
      const formatted = (price / 100).toFixed(2);
      return formatted.endsWith('.00') ? formatted.slice(0, -3) : formatted;
    }

    updateSwatchLabel(swatch) {
      const swatchContainer = swatch.closest('.ProductSwatches-category');
      const jsLabel = swatchContainer.querySelector('[data-js-pdp-color-label]');

      // Get global discount rate
      const globalDiscountRate = parseFloat(this.dataset.globalDiscountRate) || 0;

      if (jsLabel) {
        jsLabel.innerHTML = swatch.dataset.colorLabel;
        this.querySelector('.ProductSwatches-label-price')?.remove();
        this.querySelector('.flash-sale-badge-and-price')?.remove();

        let price = parseFloat(swatch.dataset.price);
        const compare = parseFloat(swatch.dataset.compare);
        const hasRegularSale = compare && price < compare;

        // Check if this is a sale swatch (has is-sale class)
        const isSaleSwatch = swatch.classList.contains('is-sale');

        if (swatch.dataset.discountValue) {
          const badgeHTML = swatch.dataset.badgeText
            ? `<span class="flash-sale-badge">${swatch.dataset.badgeText}</span>`
            : '';

          let discountPrice = price;

          if (swatch.dataset.discountType == 'Percentage') {
            discountPrice = (price * (1 - swatch.dataset.discountValue / 100)).toFixed(2);
          } else {
            discountPrice = price - swatch.dataset.discountValue * 100;
          }

          jsLabel.insertAdjacentHTML(
            'afterend',
            `
            <span class="flash-sale-badge-and-price">
              <span class="flash-sale-price">$${this.formatPrice(discountPrice)}</span>
              <s class="flash-sale-original-price">$${this.formatPrice(price)}</s>
              ${badgeHTML} 
            </span>
            `,
          );
          return;
        }

        // Apply global discount only for sale swatches
        if (globalDiscountRate > 0 && isSaleSwatch && hasRegularSale) {
          const discountFactor = (100 - globalDiscountRate) / 100;
          const globalDiscountedPrice = price * discountFactor;

          jsLabel.insertAdjacentHTML(
            'afterend',
            `<div class="ProductSwatches-label-price" style="margin-left: 4px;">
              <div class="product-price">
                <span class="Product-info-current_price body-large js-price-preview current_price on-sale">
                  <span class="sale-price">$${this.formatPrice(globalDiscountedPrice)}</span>
                  <del class="compare-price">$${this.formatPrice(compare)}</del>
                </span>
              </div>
            </div>`,
          );
        } else if (hasRegularSale) {
          jsLabel.insertAdjacentHTML(
            'afterend',
            `<div class="ProductSwatches-label-price" style="margin-left: 4px;">
              <div class="product-price">
                <span class="Product-info-current_price body-large js-price-preview current_price on-sale">
                  <span class="sale-price">$${this.formatPrice(price)}</span>
                  <del class="compare-price">$${this.formatPrice(compare)}</del>
                </span>
              </div>
            </div>`,
          );
        }
      } else {
        console.log('NOT HAS LABEL');
        this.querySelector('[data-js-pdp-color-label]')?.remove();
        this.querySelector('.ProductSwatches-label-price')?.remove();
        this.querySelector('.flash-sale-badge-and-price')?.remove();

        const label = swatchContainer.querySelector('.ProductSwatches-label');
        label.innerHTML += `<span data-js-pdp-color-label>${swatch.dataset.colorLabel}</span>`;

        let price = parseFloat(swatch.dataset.price);
        const compare = parseFloat(swatch.dataset.compare);
        const hasRegularSale = compare && price < compare;

        // Check if this is a sale swatch (has is-sale class)
        const isSaleSwatch = swatch.classList.contains('is-sale');

        console.log('TTTT');

        if (swatch.dataset.discountValue) {
          const badgeHTML = swatch.dataset.badgeText
            ? `<span class="flash-sale-badge">${swatch.dataset.badgeText}</span>`
            : '';

          let discountPrice = price;

          if (swatch.dataset.discountType == 'Percentage') {
            discountPrice = (price * (1 - swatch.dataset.discountValue / 100)).toFixed(2);
          } else {
            discountPrice = price - swatch.dataset.discountValue * 100;
          }

          label.innerHTML += `
            <span class="flash-sale-badge-and-price">
              <span class="flash-sale-price">$${this.formatPrice(discountPrice)}</span>
              <s class="flash-sale-original-price">$${this.formatPrice(price)}</s>
              ${badgeHTML} 
            </span>
          `;
          return;
        }

        // Apply global discount only for sale swatches
        if (globalDiscountRate > 0 && isSaleSwatch && hasRegularSale) {
          const discountFactor = (100 - globalDiscountRate) / 100;
          const globalDiscountedPrice = price * discountFactor;

          label.innerHTML += `
            <div class="ProductSwatches-label-price" style="margin-left: 4px;">
              <div class="product-price">
                <span class="Product-info-current_price body-large js-price-preview current_price on-sale">
                  <span class="sale-price">$${this.formatPrice(globalDiscountedPrice)}</span>
                  <del class="compare-price">$${this.formatPrice(compare)}</del>
                </span>
              </div>
            </div>`;
        } else if (hasRegularSale) {
          label.innerHTML += `
            <div class="ProductSwatches-label-price" style="margin-left: 4px;">
              <div class="product-price">
                <span class="Product-info-current_price body-large js-price-preview current_price on-sale">
                  <span class="sale-price">$${this.formatPrice(price)}</span>
                  <del class="compare-price">$${this.formatPrice(compare)}</del>
                </span>
              </div>
            </div>`;
        }
      }
    }

    handleQuickshopSwatchClick(event) {
      const handle = event.target.closest('.swatch').dataset.handle;
      const quickshopDrawer = this.closest('quickshop-drawer');

      // Capture currently selected sizes before switching
      const checkedInputs = quickshopDrawer.querySelectorAll('.quickshop-product-option-input:checked');
      const selectedSizes = Array.from(checkedInputs).map((input) => input.dataset.size);

      quickshopDrawer.fetchContent(handle, selectedSizes);
    }

    handleBundleSwatchClick(event) {
      const swatch = event.target.closest('.swatch');
      const productUrl = swatch.dataset.url.split('?')[0];

      const dataHandle = swatch.dataset.handle;
      const embroideryPopup = document.querySelector('embroidery-popup');

      const container = event.target.closest('.js-smp-bundle-snippet');
      const collectionHandle = window.location.pathname.split('/').pop();

      if (embroideryPopup && dataHandle && container.dataset.hasEmbroidery == 'true') {
        embroideryPopup.dataset.productHandle = dataHandle;
      }

      const smpBundle = container.closest('smp-bundle');

      const sizeLabels = container.querySelectorAll('.quickshop-product-option-input:checked + label');
      const sizeString =
        sizeLabels && sizeLabels.length > 0
          ? Array.from(sizeLabels)
              .map((label) => label.innerText)
              .join(',')
          : '';

      fetch(productUrl + '?section_id=smp-bundle-product&path=%2Fcollections%2F' + collectionHandle)
        .then((res) => res.text())
        .then((html) => {
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, 'text/html');

          const { processedHtml, uniqueId: processedUniqueId } = window.bundleIdManager.processFetchedHtml(
            html,
            swatch.dataset.handle || 'unknown',
          );

          doc.body.innerHTML = processedHtml;
          const newContainer = doc.querySelector('.js-smp-bundle-snippet-container');

          if (newContainer && container) {
            container.querySelectorAll('input:checked').forEach((input) => {
              const newInput = newContainer.querySelector(`input[data-size="${input.dataset.size}"]`);

              if (newInput) {
                newInput.setAttribute('checked', 'checked');
              }
            });
            container.innerHTML = newContainer.innerHTML;
            smpBundle.optionInputs = smpBundle.querySelectorAll('.quickshop-product-option-input');
            smpBundle.attachOptionChangeListeners();
          }
          smpBundle.recalculateSelectedItems();
          smpBundle.updateAddToCartState();
        });
    }

    updateAvailabilityStyle() {
      const collectionHandle = this.dataset.collectionHandle;

      if (!collectionHandle) {
        console.error('Collection handle is missing from dataset');
        return;
      }

      let fetchString = `/collections/${collectionHandle}?view=collection-json&filter.v.availability=1`;
      let variantSelects = document.querySelector('variant-selects');

      if (this.isBundle) {
        variantSelects = this.closest('.smpbundle-Product-sections').querySelector('.smpbundle-Product-controls');
      }

      if (this.isQuickshop) {
        variantSelects = this.closest('quickshop-drawer').querySelector('.quickshop-options-container');
      }

      if (!variantSelects) {
        console.error('variant-selects element not found');
        return;
      }

      if (variantSelects.dataset.sizing == 'regular') {
        const sizeInput = variantSelects.querySelector('input:checked');
        if (!sizeInput) {
          console.error('No checked size input found');
          return;
        }
        const size = this.isBundle || this.isQuickshop ? sizeInput.dataset.size : sizeInput.value;
        fetchString += `&filter.v.option.size=${size}`;
      } else if (variantSelects.dataset.sizing == 'gift') {
        const sizeInput = variantSelects.querySelector('input:checked');
        if (!sizeInput) {
          console.error('No checked size input found');
          return;
        }
        const size = sizeInput.value;
        fetchString += `&filter.v.option.value=${size}`;
      } else {
        const sizes = variantSelects.querySelectorAll('input:checked');
        if (sizes.length === 0) {
          console.error('No checked size inputs found');
          return;
        }
        sizes.forEach((size, index) => {
          if (index == 0) {
            fetchString += `&filter.v.option.band+size=${this.isBundle || this.isQuickshop ? size.dataset.size : size.value}`;
          } else if (index == 1) {
            fetchString += `&filter.v.option.cup+size=${this.isBundle || this.isQuickshop ? size.dataset.size : size.value}`;
          }
        });
      }

      fetch(fetchString)
        .then((res) => {
          if (!res.ok) {
            throw new Error(`HTTP error! status: ${res.status}`);
          }
          return res.json();
        })
        .then((data) => {
          if (!data.availableColors) return;
          const colors = data.availableColors.map((color) => color.toLowerCase().replace(' ', '-'));
          this.swatches.forEach((swatch) => {
            const color = swatch.dataset.colorLabel;
            if (colors.includes(color)) {
              swatch.querySelector('.swatch-inner').classList.remove('swatch--oos');
            } else {
              swatch.querySelector('.swatch-inner').classList.add('swatch--oos');
            }
          });
        })
        .catch((error) => {
          console.error('Fetch error:', error);
        });
    }
  }

  customElements.define('product-swatches', ProductSwatches);
}
